import { en } from './en.js';
import { es } from './es.js';
import { interpolate } from './keys.js';
export { en } from './en.js';
export { es } from './es.js';
export * from './keys.js';
/**
 * Both catalogues, keyed by locale, so a caller resolves a message without a switch statement that
 * some later language would have to be remembered into.
 */
export const CATALOGUES = { es, en };
/** The catalogue for a locale. Total over `Locale`, so there is no missing-language branch. */
export function catalogueFor(locale) {
    return CATALOGUES[locale];
}
/**
 * Resolves one key in one language and substitutes its allowlisted placeholders.
 *
 * There is deliberately no fallback to the other language and no fallback to the key itself: both
 * catalogues are complete by type and by gate, so a missing key here would be a defect that a
 * fallback would hide until a user met it.
 */
export function translate(locale, key, params) {
    return interpolate(catalogueFor(locale)[key], params);
}
/**
 * Whether a string names a real message key.
 *
 * **It exists because several producers of an `ErrorDetail` hold a `string`.** Zod's own issue
 * messages, `checkSettingsCoherence`'s problem list and a validator compiled from a stored field
 * definition all produce a message as a plain string, and `ErrorDetail.messageKey` is deliberately
 * the narrow union: a detail that carried arbitrary prose would reflect the submitted value, which
 * for this product means a name, a passport number or a pass code in an error body, a log line and
 * a screenshot. The narrowing has to happen somewhere, and the only honest place is beside the
 * catalogue that decides what a real key is.
 *
 * The Spanish catalogue is the one it checks, and the parity gate is what makes that sufficient:
 * `test:i18n` refuses a key present in one language and absent in the other, so the two key sets
 * are equal by construction and consulting either answers the question.
 */
export function isMessageKey(value) {
    return Object.hasOwn(es, value);
}
//# sourceMappingURL=index.js.map